<template>
  <div>
    <form-with-data ref="formData"  :is-edit="isEdit" :id="id" @submitLoad="submitLoad"></form-with-data>
    <div :class="$style['group-form-button-div']" v-if="queryParamsType!=='detail'">
        <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import formWithData from './withData.vue'
export default {
  components: {
    formWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      queryParamsType: {}
    }
  },
  methods: {
    submit () {
      this.$refs.formData.submit()
    },
    cancel () {
      this.$refs.formData.cancel()
    },
    submitLoad (val) {
      this.loading = val
    }
  },
  created () {
    this.queryParamsType = this.$route.query && this.$route.query.type
  }
}
</script>
<style module lang="less">
.group-form-button-div{
    margin-top: 30px;
}
</style>
